// import { itemCommonUtilis } from 'item-component'
import { LoginRedirectPath, findAppPath } from '../globalUtils/searchUtills'
export const envExternalConfigs = {
  local: {
    auth: {
      loginRedirect: `${window.location.origin}/auth/login`,
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      // uri: 'http://localhost:9001/graphql', Remove local dependency
      uri: 'https://launchpadgraphql.dev.target.com/graphql',
    },
    launchpad: {
      host: 'http://localhost:3000',
    },
    support: {
      host: 'https://www.partnersonline.com/page/help',
    },
  },
  dev: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      uri: 'https://stage-api.target.com/graphql_launchpad/v1',
    },
    launchpad: {
      // host: 'https://xycpre-launchpad.partnersonline.com/v2',
      host: `${findAppPath()}/v2`,
    },
    support: {
      host: 'https://www.partnersonline.com/page/help',
    },
  },
  stg: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      uri: 'https://stage-api.target.com/graphql_launchpad/v1',
    },
    launchpad: {
      // host: 'https://xycpre-launchpad.partnersonline.com/v2',
      host: `${findAppPath()}/v2`,
    },
    support: {
      host: 'https://www.partnersonline.com/page/help',
    },
  },
  prod: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      uri: 'https://api.target.com/graphql_launchpad/v1',
    },
    launchpad: {
      // host: 'https://launchpad.partnersonline.com/v2',
      host: `${findAppPath()}/v2`,
    },
    support: {
      host: 'https://www.partnersonline.com/page/help',
    },
  },
}
